import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

/**
 * Wraps a route to require auth.
 * Optionally restrict by role: <ProtectedRoute roles={["admin"]}>...</ProtectedRoute>
 */
export default function ProtectedRoute({ children, roles }) {
  const { user } = useAuth();
  const location = useLocation();

  // Still checking session
  if (user === null) {
    return (
      <div
        data-testid="auth-loading"
        className="min-h-screen flex items-center justify-center bg-[#F5F5F5] text-[#475569] text-sm tracking-wide"
      >
        <span className="inline-flex items-center gap-2">
          <span className="w-2 h-2 bg-[#1E4D55] rounded-full animate-pulse" />
          Checking session…
        </span>
      </div>
    );
  }

  // Not authenticated
  if (user === false) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  // Role restriction
  if (roles && roles.length > 0 && !roles.includes(user.role)) {
    return <Navigate to={`/dashboard/${user.role}`} replace />;
  }

  return children;
}
